// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?id=" + {"24":"4befbd851234ff1f","519":"99d4e0c3b8e8ff0e","876":"e8a67e34bcddc52b"}[chunkId] + "";
};